import React, { useEffect } from "react";
import AccordionSimple from "components/accordion/AccordionSimple";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

function FAQs({ data }) {
  const { hash } = useLocation();
  const isMobileSize = useMediaQuery({ maxWidth: 1200 });

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        setTimeout(() => {

          const yOffset = isMobileSize ? -200 : -280;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 300);
      }
    }
  }, [hash]);

  return (
    <section
      className="section about container"
      data-aos="fade-up"
      data-aos-delay="200"
    >
      <div className="d-flex mb-md-5 py-md-4 justify-content-center align-text-center">
        <h1 id="faq-title" className="heading">
          Frequently Asked Questions
        </h1>
      </div>
      <div className="col-xl-10 mx-auto">
        <AccordionSimple
          data={data?.faqData}
          toggleButton={true}
          viewAllButton={data?.faqData?.length > 8}
        />
      </div>
    </section>
  );
}

export default FAQs;